import { createSelector } from 'reselect';

import { AppState } from '../rootReducer';

const getItems = (state: AppState) => state.ARRequestInvoices.items;
const getItemView = (state: AppState) => state.ARRequestInvoices.itemView;

export const getARRequestInvoicesSelector = createSelector(getItems, items => items);
export const getARRequestInvoicesViewSelector = createSelector(getItemView, itemView => itemView);
